
import React from 'react';
import './policies.css';

function CancellationReplacementPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Cancellation & Replacement Policy</h1>

        <p className="last-updated">
          Last Updated: June 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            At <strong>Mr White</strong>, we understand that sometimes changes
            need to be made regarding your laundry orders. This Cancellation &
            Replacement Policy outlines the conditions and procedures for
            canceling and replacing your orders.
          </p>
        </div>

        <div className="policy-section">
          <h2>1. Cancellation Policy</h2>

          <p>
            You may cancel your order under the following conditions:
          </p>

          <ul className="policy-list">
            <li>
              <strong>Cancellation Before Pick-Up:</strong> Orders can be
              canceled without penalty if you notify us at least 2 hours before
              the scheduled pick-up. To cancel your order, please contact our
              customer service team.
            </li>

            <li>
              <strong>Cancellation After Pick-Up:</strong> Once your laundry
              has been picked up, cancellations are not accepted as the
              processing of the order has already started.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>2. Replacement Policy</h2>

          <p>
            We offer replacements under the following circumstances:
          </p>

          <ul className="policy-list">
            <li>
              <strong>Wrong Item Received:</strong> If we mistakenly process
              and return an incorrect item, please notify us within 24 hours of
              receiving your laundry. We will arrange for the correct item to
              be returned to you at no additional cost.
            </li>

            <li>
              <strong>Defective Items:</strong> If your item is returned with
              defects that are inconsistent with the requested service (for
              example, damage occurring during washing or processing), please
              report the issue within 24 hours of delivery. We will review the
              matter and provide a replacement or suitable compensation where
              applicable.
            </li>

            <li>
              <strong>Damage During Shipping:</strong> If your item is damaged
              during transit, please contact us immediately and provide
              photographic evidence within 24 hours of receiving the item. We
              will evaluate the claim and arrange a replacement if applicable.
            </li>

            <li>
              <strong>Late Delivery:</strong> If your laundry is not delivered
              within the agreed timeframe (excluding unforeseen circumstances),
              you may be eligible for a replacement or refund. Please notify us
              within 24 hours of the missed delivery.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Reporting Issues</h2>

          <p>
            To request a cancellation or replacement, please provide the
            following details:
          </p>

          <ul className="policy-list">
            <li>Your order number.</li>
            <li>A detailed description of the issue.</li>
            <li>Photographic evidence, if applicable.</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Contact Us</h2>

          <p>
            For cancellation requests or replacement inquiries, please contact
            our customer service team:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>

          <p>
            We are always happy to assist you and ensure the best possible
            service experience.
          </p>
        </div>

      </div>
    </div>
  );
}

export default CancellationReplacementPolicy;

